import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import * as _ from 'underscore';
import {Flat} from '../../../shared/models/flat.model';
import {FlatManagerService} from '../../../shared/service/flat-manager.service';
import {HomeCarouselService} from '../../../shared/service/home-carousel.service';
import {HomeCarouselItemsModel} from '../../../shared/models/home-carousel-items.model';
import {HomeCarouselModel} from '../../../shared/models/home-carousel.model';
import {FlatUtilService} from '../../../shared/util/flat-util.service';

@Component({
  selector: 'app-flat',
  templateUrl: './flat.component.html',
  styleUrls: ['./flat.component.scss']
})
export class FlatComponent implements OnInit {

  projectId: string;
  flat: Flat;
  flatId: string;
  visualizationImageLoaded: boolean;
  homeCarouselItems: HomeCarouselModel[];
  selectedSide: HomeCarouselModel;
  showFlag = false;
  selectedImageIndex = -1;
  galleryImageList: object[] = [];

  constructor(private location: Location,
              private flatService: FlatManagerService,
              private router: Router,
              private route: ActivatedRoute,
              private homeCarouselService: HomeCarouselService,
              private flatUtil: FlatUtilService) {
    this.initFacebookApp();

    this.homeCarouselService.homeCarouselItems.subscribe((homeCarousel: HomeCarouselItemsModel) => {
      if (homeCarousel.items) {
        this.homeCarouselItems = homeCarousel.items;
      }
    });

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.flatId = this.route.snapshot.params['id'];

      this.flatService.getFlat(this.flatId).subscribe((flat: Flat) => {
        this.selectedSide = this.homeCarouselItems.find(item => item.side === flat.side);
        this.flat = flat;
        this.initGallery();
      });
    });

  }

  backToPrevPage() {
    this.location.back();
  }

  removeHuf(priceString) {
    return priceString.replace('HUF', '');
  }

  getTerraceSize() {
    return this.flatUtil.getTerraceSize(this.flat);
  }

  getFlatRectPosition(getX: boolean) {

    if (!this.visualizationImageLoaded) {
      return 0;
    }

    const elements = document.getElementsByClassName('visualization-image');

    if (!elements || !elements.length) {
      return 0;
    }

    const element = document.getElementsByClassName('visualization-image')[0];
    const ratio = element['naturalWidth'] / element['offsetWidth'];

    if (getX) {
      return (this.flat.coordinateX / ratio) - (25 / ratio);
    } else {
      return (this.flat.coordinateY / ratio) - (25 / ratio);
    }
  }

  getFlatRectHeight() {

    if (!this.visualizationImageLoaded) {
      return 0;
    }

    const elements = document.getElementsByClassName('visualization-image');

    if (!elements || !elements.length) {
      return 0;
    }

    const element = document.getElementsByClassName('visualization-image')[0];
    const ratio = element['naturalWidth'] / element['offsetWidth'];
    return 50 / ratio;

  }


  initFacebookApp() {
    if (!window['fbAsyncInit']) {
      window['fbAsyncInit'] = function () {
        window['FB'].init({
          autoLogAppEvents: true,
          xfbml: true,
          appId: '170555663821545',
          version: 'v3.0'
        });
      };
    }

    // load facebook sdk if required
    const url = 'https://connect.facebook.net/en_US/sdk.js';
    if (!document.querySelector(`script[src='${url}']`)) {
      const script = document.createElement('script');
      script.src = url;
      document.body.appendChild(script);
    }
  }


  initGallery() {
    this.galleryImageList = [
      {
        image: this.flat.layoutImageUrl,
        thumbImage: this.flat.layoutImageUrl,
        alt: '',
        title: ''
      },
      {
        image: this.flat.salesImageUrl,
        thumbImage: this.flat.salesImageUrl,
        alt: '',
        title: ''
      },
      {
        image: this.flat.buildingInImageUrl,
        thumbImage: this.flat.buildingInImageUrl,
        alt: '',
        title: ''
      }
    ];
  }


  getFlatPositionImageUrl() {

    if (!this.flat || !this.flat['name']) {
      return '';
    }


    if (this.flat.concatImageUrl) {
      return this.flat.concatImageUrl;
    }


    const flatNameInImage = this.flat.name.replace('/', '_').replace('/', '_').toUpperCase();
    return '/assets/images/flats/flat_position/' + flatNameInImage + '_p.jpg';
  }

  showLightbox(index) {
    this.selectedImageIndex = index;
    this.showFlag = true;
  }

  closeEventHandler() {
    this.showFlag = false;
    this.selectedImageIndex = -1;
  }

}
